import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Image from 'components/widgets/Image';
import PropTypes from 'prop-types';

/**
 * TeamMemberView
 * Reusable component that renders a single team member block.
 * Props:
 * - name: string (display name)
 * - title: string (role/title)
 * - src: string (image src)
 * - alt: string (image alt)
 * - xs: number | boolean (Grid xs prop, default 4)
 * - className: optional className passed to Grid
 */
const TeamMemberView = ({ name, title, src, alt, className }) => {
  const imgStyle = { maxWidth: '100%', height: 'auto', display: 'block' };

  return (
    <Box className={className} sx={{ height: '100%' }}>
      <Box sx={{ backgroundColor: '#ffffff', border: '10px solid rgba(0,0,0,0.06)', p: 2, borderRadius: 1, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Image alt={alt || name} src={src} style={imgStyle} />
        <Typography variant="h6" component="p" sx={{ mt: 1, mb: 0 }}>
          {name}
        </Typography>
        {title && (
          <Typography variant="body2" component="p">
            {title}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

TeamMemberView.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  className: PropTypes.string,
  photoSize: PropTypes.shape({ width: PropTypes.number, height: PropTypes.number }),
};

export default TeamMemberView;
